import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDialog = styled(Dialog)({
  padding: 0,
  margin: 0,
  container: {
    padding: 0,
    margin: 0,
  },
  paper: {
    padding: 0,
    margin: 0,
  },
  paperScrollPaper: {
    padding: 0,
    margin: 0,
  },
});

export const StyledDialogTitle = styled(DialogTitle)({
  textAlign: "-webkit-center",
  padding: 0,
  margin: 0,
});

export const StyledDialogContent = styled(DialogContent)({
  padding: 0,
  margin: 0,
  overflowX: "hidden",
});
